// ─────────────────────────────────────────────────────────────────────────────
// stores/authStore.ts – Firebase Auth Pinia Store
//
// ── DIE ROLLE KOMMT AUS DEM ANSPRUCH, NICHT AUS EINEM FELD (T-M30.7) ────────
// (REQ-SEC-027, REQ-SEC-028, REQ-SEC-029 (b), REQ-DM-070)
// Seit dem 2026-09-01 gilt: `isAdmin` und die Mandanten des Benutzers stehen im
// CUSTOM CLAIM des ID-Tokens (`admin`, `companyIds`) — in derselben Quelle, die
// auch die Rules pruefen. Der Anspruch wird beim Anmelde-Start ERZWUNGEN
// aufgefrischt (REQ-SEC-028 (f)); die Rechnung selbst liegt in
// `utils/anspruch.ts` und nicht hier.
// **Zwei Dinge sind damit fort und stehen nicht mehr in diesem Store:** der
// Erstlogin-Guard, der ein `users`-Dokument ANLEGTE (REQ-SEC-029 (b) Praez. 1),
// und die Ableitung `AppUser.companyId` (REQ-DM-070 (e)). Beide sind an ihrer
// Stelle mit Datum vermerkt.
//
// ── DER ANMELDE-START ENDET IN JEDEM FALL (T-M21.2, REQ-OPS-052) ────────────
// Bis zum 2026-08-18 lief `init()` ohne Fehlerpfad: `await fetchAppUser(user)`
// stand ungeschuetzt im Rueckruf von `onAuthStateChanged`, und `isLoading` fiel
// erst DANACH. Warf das Lesen des Profils — oder seine Erstanlage, die beim
// ersten Login SCHRIEB (bis T-M30.7; sie ist entfallen, siehe oben) —,
// blieb der Ladezustand stehen; antwortete Firestore
// gar nicht, ebenso. Die Oberflaeche zeigte dann unbegrenzt den Ladebalken und
// meldete nichts. Genau das ist das Feldsymptom (b) vom 2026-08-17/18.
//
// Seither gilt: JEDER Ausgang des Starts nimmt den Ladezustand zurueck —
// Erfolg, Fehler und Fristablauf. Ein Scheitern traegt einen benannten Zustand
// (`bootstrapError`) mit FEHLERCODE (REQ-OPS-052 (c)); die Fehleransicht in
// `App.vue` bietet genau zwei Handlungen an, und „Erneut versuchen" ruft
// `retryBootstrap()` — ohne die Seite neu zu laden (REQ-OPS-054 (d)).
//
// Die Schritte werden ueber `utils/diagnose.ts` MIT DAUER protokolliert
// (REQ-OPS-055 (b)): ohne sie ist beim naechsten Auftreten nicht
// unterscheidbar, ob ein Schritt FEHLSCHLUG oder HAENGT.
//
// NICHT Gegenstand dieses Umbaus ist das Sitzungsverhalten: die 12-Stunden-
// Regel und die ungleiche Behandlung des fehlenden Zeitstempels bleiben
// unveraendert (REQ-OPS-056, Traeger T-M21.3).
//
// ── DIE ZWEI SITZUNGSSTELLEN SIND ABSICHTLICH UNGLEICH (T-M21.3) ────────────
// Der fehlende `pf_login_at` wird an den zwei Stellen dieser Datei VERSCHIEDEN
// behandelt, und das ist entschieden (REQ-OPS-056, Auftraggeber 2026-08-18):
//
//   • `checkSessionExpiry()` — der Waechter bei JEDER Navigation:
//        fehlender Zeitstempel  →  ABGELAUFEN  →  abmelden.
//        Die Sitzung ist nicht rekonstruierbar; die sicherere Wahl gewinnt.
//   • `verarbeiteAnmeldezustand()` — das ERSTE Aufloesen der Anmeldung in
//     `init()`:
//        fehlender Zeitstempel  →  FRISCH  →  Zeitstempel setzen, weitermachen.
//
// **DAS SIEHT WIE EIN WIDERSPRUCH AUS UND IST KEINER.** Der Grund liegt in
// `login()` weiter unten: **der Anmeldeweg selbst schreibt den Zeitstempel
// nicht.** Nach einer erfolgreichen Anmeldung ist `pf_login_at` genau so lange
// nicht gesetzt, bis `init()` ihn setzt. Behandelte `init()` ihn wie der
// Waechter — als abgelaufen —, wuerde **JEDE FRISCHE ANMELDUNG SICH SOFORT
// WIEDER ABMELDEN**, und niemand kaeme mehr ins Dashboard.
//
// ⚠ **WER DIE ZWEI STELLEN „VEREINHEITLICHT", MACHT DIE ANMELDUNG UNMOEGLICH**
// (REQ-OPS-056 (b)). Ein Waechter verteidigt das:
// `dashboard/test/sitzungsAsymmetrie.test.ts` haelt beide Zweige und faellt rot
// mit genau dieser Begruendung. Wer die Asymmetrie dennoch aufloesen will, muss
// zuerst den Zeitstempel dorthin verlegen, wo die Anmeldung geschieht — das ist
// ein neuer Sitzungsentwurf und braucht einen Entscheid des Auftraggebers, kein
// Aufraeumen.
//
// Beide Entscheide werden ueber `diagnoseSessionDecision` protokolliert
// (REQ-OPS-056 (c)): gelesener Wert, Alter (`null`, wenn keines lesbar ist —
// der Fall „kein Zeitstempel" ist gerade der Befund), Verdikt und welche der
// zwei Stellen entschieden hat (`source`).
//
// GRENZE, benannt (REQ-OPS-056 (e)): `localStorage` ist tabuebergreifend und
// kann vom Browser unabhaengig von der Anmeldung geraeumt werden. Ein
// geraeumter Zeitstempel fuehrt beim naechsten Navigieren zu einer Abmeldung,
// die fuer den Nutzer wie ein Zufall aussieht. Das Verhalten wird hier NICHT
// geaendert — es wird ablesbar gemacht.
//
// ── EIN ANZEIGE-TOKEN IST KEINE ANMELDUNG (T-M24.2, 2026-08-22) ────────────
// (REQ-OPS-052 Praez. 1, REQ-SC-050, REQ-SEC-012)
// Bis zum 2026-08-22 lief eine ueber `screentoken` ausgestellte Sitzung durch
// diesen Start wie eine Verwaltungssitzung: Sitzungsmarke setzen, `users/{uid}`
// lesen — und dort weisen die Rules den Anzeige-Anspruch ab. Das Ergebnis war
// ein `bootstrapError` mit `permission-denied` und eine Fehleransicht, aus der
// „Erneut versuchen" zwangslaeufig wieder an dieselbe Stelle fuehrte (Meldung
// Tim Schuetz 2026-08-19, Punkt 4a; reproduziert in T-M24.1).
//
// Seither gilt: eine solche Sitzung gilt beim Start als **NICHT ANGEMELDET**.
// Sie wird abgemeldet, der Start endet REGULAER, und der Router-Waechter fuehrt
// mangels Anmeldung nach `/login` — **kein `bootstrapError`, keine
// Fehleransicht, kein Ladezustand ohne Ende.** Der Fehlerpfad ist damit nicht
// entschaerft, sondern um einen Fall entlastet, der keiner ist.
//
// DREI Dinge daran sind Absicht und keine Beilaeufigkeit:
//   • **Erkannt wird am ANSPRUCH** (`getIdTokenResult().claims.screen`), nicht
//     am Ausgang des Firestore-Lesevorgangs. Ein an `permission-denied`
//     festgemachter Zweig faenge auch den ECHTEN Rechtefehler und verdeckte
//     REQ-SEC-011.
//   • **Die Erkennung steht VOR dem Sitzungszweig**, sonst hinterlaesst eine
//     Bildschirm-Sitzung die Marke `pf_login_at` einer Verwaltungssitzung.
//     REQ-OPS-056 bleibt davon unangetastet; an der Asymmetrie der zwei Stellen
//     aendert sich nichts.
//   • **Sie greift NUR am Portal**, nicht in den drei Bildschirm-Ansichten —
//     die melden sich mit genau so einer Sitzung an und benutzen dieselbe
//     Auth-Instanz. Das Tor liegt in `utils/bildschirmSitzung.ts`, dort steht
//     auch die Begruendung im Einzelnen.
// ─────────────────────────────────────────────────────────────────────────────

import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import {
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  type User,
} from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db }    from '@/firebase/config';
import type { AppUser } from '@/firebase/models';
import { isSessionExpired, sessionAgeMs } from '@/stores/session';
import { diagnoseAuthState, diagnoseBootstrapStep, diagnoseSessionDecision } from '@/utils/diagnose';
import { erkenneBildschirmSitzungAmPortal, istPortalPfad } from '@/utils/bildschirmSitzung';
import { leseAnspruch, mitAnspruchsWiederholung, type Anspruch } from '@/utils/anspruch';

// ── Session Config ─────────────────────────────────────────────────────────────
const SESSION_KEY      = 'pf_login_at';                      // localStorage key
// Ablauf-Grenze (12 h) und Pruefung liegen in stores/session.ts (isSessionExpired),
// damit die Logik ohne Firebase-Abhaengigkeit isoliert testbar ist.

/**
 * Obergrenze des Anmelde-Starts in Millisekunden (REQ-OPS-052 (b)).
 *
 * **Der Wert ist gesetzt und wird nicht beilaeufig geaendert.** Er ist die
 * Abwaegung zwischen zwei Fehlern: zu kurz, und ein schlechtes Mobilnetz oder
 * ein kalter Firestore-Start bricht einen Start ab, der noch gelungen waere;
 * zu lang, und der Nutzer haelt den Ladebalken fuer „haengt fuer immer" —
 * genau der Zustand, den dieser Umbau beseitigt. 15 Sekunden liegen ueber jeder
 * gemessenen gesunden Anmeldung und unter der Geduld eines Bedieners.
 *
 * **Die Frist gilt an ZWEI Stellen und steht deshalb hier an EINER:** im Store
 * (dieser Datei) und im Router-Waechter (`router/index.ts`), der nie laenger
 * auf das Ende des Ladezustands wartet als der Start selbst dauern darf
 * (REQ-OPS-052 (e)).
 */
export const BOOTSTRAP_TIMEOUT_MS = 15_000;

/**
 * Der Code des Fristablaufs.
 *
 * Firebase liefert hier keinen — es hat ja nicht geantwortet. Der Code traegt
 * trotzdem die Form eines Firebase-Codes (`bereich/ursache`), damit die
 * Fehleransicht und die Suche im Feld nicht zwei Formen kennen muessen
 * (REQ-OPS-052 (c): ein Fehlerzustand ohne Code ist keiner).
 */
export const BOOTSTRAP_TIMEOUT_CODE = 'bootstrap/timeout';

/**
 * Der Code des FEHLENDEN BENUTZERPROFILS (T-M30.7, REQ-SEC-029 (b),
 * REQ-DM-070 (e)).
 *
 * ⚠ **Bis zum 2026-09-01 gab es diesen Zustand nicht — es gab statt seiner
 * einen SCHREIBVORGANG.** `fetchAppUser` legte beim Erstlogin selbst ein
 * `users`-Dokument mit `role: 'user'` und leerer `companyId` an. Genau dieser
 * Weg ist der kuerzeste zur Rechteausweitung, sobald Kunden sich anmelden, und
 * er entfaellt: **kein Client schreibt sein eigenes `users`-Dokument**
 * (REQ-SEC-029 (b) Praez. 1). Das Profil entsteht ausschliesslich in
 * `acceptinvitation` (REQ-SEC-030).
 *
 * Ein fehlendes Profil ist damit ein BENANNTER FEHLERZUSTAND und kein Anlass
 * zum Schreiben; die Fehleransicht nennt ihn und verweist an den Administrator.
 */
export const PROFIL_FEHLT_CODE = 'profile/missing';

/** Der benannte Fehlerzustand des Starts (REQ-OPS-052 (c)). */
export interface BootstrapError {
  /** Firebase-Fehlercode bzw. `bootstrap/timeout`; nie leer. */
  code:    string;
  /** Der Meldungstext des Fehlers — fuer die Diagnose, nicht fuer die Anzeige. */
  message: string;
}

/**
 * Code und Meldung eines geworfenen Werts, ohne je selbst zu werfen.
 *
 * Ein Firebase-Fehler traegt `code` (`permission-denied`, `unavailable`,
 * `auth/network-request-failed`, …). Fehlt er, steht `unknown` — ein leerer
 * Code waere schlimmer als ein ehrlich unbekannter.
 */
function fehlerAngaben(err: unknown): BootstrapError {
  const e = err as { code?: unknown; message?: unknown } | null;
  const code    = typeof e?.code === 'string' && e.code ? e.code : 'unknown';
  const message = typeof e?.message === 'string' && e.message ? e.message : String(err);
  return { code, message };
}

/**
 * Die zwei Stellen, die ueber die Sitzung entscheiden (REQ-OPS-056 (c)).
 *
 * Sie stehen als Werte im Protokoll, damit im Feld nicht geraten werden muss,
 * WELCHE der beiden entschieden hat — die Frage ist bei dieser Anforderung die
 * ganze Sache.
 */
export const SITZUNGSSTELLE = {
  /** Das erste Aufloesen der Anmeldung in `init()`: fehlend = frisch. */
  start:   'init',
  /** Der Waechter bei jeder Navigation: fehlend = abgelaufen. */
  waechter: 'checkSessionExpiry',
} as const;

/**
 * Das Verdikt eines Sitzungsentscheids — technisch-englisch, wie jeder
 * Schluessel im Protokoll.
 *
 * `screenToken` (T-M24.2, 2026-08-22) ist KEIN viertes Verdikt der
 * 12-Stunden-Regel, sondern das der EINEN Erkennung aus REQ-OPS-052 Praez. 1:
 * die Sitzung ist gar keine Verwaltungssitzung. Es faellt vor den zwei Stellen
 * aus REQ-OPS-056 und laesst deren Zweige unberuehrt.
 */
export type SitzungsVerdikt = 'fresh' | 'valid' | 'expired' | 'screenToken';

/**
 * Eine Zeile des Diagnose-Protokolls je Sitzungsentscheid (REQ-OPS-056 (c),
 * REQ-OPS-055 (b)).
 *
 * Sie traegt vier Angaben, und jede hat einen Grund:
 *   • `loginAt`  — der GELESENE Rohwert, ausdruecklich auch `null`. Der Fall
 *                  „kein Zeitstempel" ist der Befund, um den es geht; ein
 *                  weggelassenes Feld waere hier gerade die fehlende Aussage.
 *   • `ageMs`    — das Alter, `null` wenn keines lesbar ist. Erst damit ist im
 *                  Feld unterscheidbar, ob eine Sitzung ALT war oder GAR NICHT
 *                  DA.
 *   • `verdict`  — was entschieden wurde.
 *   • `source`   — WELCHE der zwei Stellen es entschieden hat.
 *
 * Stufe: `expired` ist behebbar (neu anmelden) und damit `warn`; die uebrigen
 * sind Uebergaenge und damit `info` (REQ-OPS-055 (c)).
 */
function protokolliereSitzungsentscheid(
  stelle:   (typeof SITZUNGSSTELLE)[keyof typeof SITZUNGSSTELLE],
  storedAt: string | null,
  verdict:  SitzungsVerdikt,
): void {
  diagnoseSessionDecision(
    verdict,
    { loginAt: storedAt, ageMs: sessionAgeMs(storedAt), verdict, source: stelle },
    verdict === 'expired' ? 'warn' : 'info',
  );
}

export const useAuthStore = defineStore('auth', () => {
  // ── State ──────────────────────────────────────────────────────────────────
  const firebaseUser  = ref<User | null>(null);
  const appUser       = ref<AppUser | null>(null);
  const isLoading     = ref(true);   // true until onAuthStateChanged fires once
  const error         = ref<string | null>(null);
  /**
   * Der Start ist gescheitert (Fehler oder Fristablauf) — REQ-OPS-052 (c).
   * Solange dieser Wert steht, zeigt `App.vue` die Fehleransicht statt des
   * Ladebalkens; `retryBootstrap()` nimmt ihn zurueck.
   */
  const bootstrapError = ref<BootstrapError | null>(null);

  let _initialized = false;  // guard: prevent multiple onAuthStateChanged listeners
  /** Abmelder des laufenden `onAuthStateChanged` — gebraucht fuer den Neuversuch. */
  let _abmelder: (() => void) | null = null;
  /** Laufende Nummer des Starts; ein Neuversuch erhoeht sie und entwertet den vorigen. */
  let _lauf = 0;
  /** Zeitgeber der Frist; `null`, sobald der Start beendet ist. */
  let _frist: ReturnType<typeof setTimeout> | null = null;
  /** Ist der laufende Start bereits beendet (auf welchem Weg auch immer)? */
  let _startBeendet = true;
  /** Beginn des laufenden Starts — Bezugspunkt der protokollierten Dauer. */
  let _startBegonnen = 0;

  /**
   * DER ANSPRUCH AUS DEM CUSTOM CLAIM (T-M30.7, REQ-SEC-028).
   *
   * `null`, solange er nicht gelesen ist. **Die Rolle kommt ab jetzt von hier
   * und nicht mehr aus `users/{uid}.role`** — aus derselben Quelle, die auch
   * die Rules pruefen (REQ-SEC-029). Ein zweiter Leseweg auf dieselbe Tatsache
   * waere die Doppelfuehrung, die REQ-SEC-031 (a) benennt.
   */
  const anspruch = ref<Anspruch | null>(null);

  // ── Computed ───────────────────────────────────────────────────────────────
  const isAuthenticated = computed(() => firebaseUser.value !== null);
  /**
   * ⚠ AUS DEM CLAIM, NICHT AUS DEM FELD (REQ-SEC-028 (a), REQ-SEC-031 (a)).
   * *Bis zum 2026-09-01 stand hier `appUser.value?.role === 'admin'` — ein
   * Lesevorgang auf ein Dokument, dessen Lesbarkeit selbst vom Anspruch
   * abhaengt. Berichtigt statt geloescht (REQ-OPS-036 Praez. 6).*
   */
  const isAdmin    = computed(() => anspruch.value?.istAdmin === true);
  /** Die Mandanten des Anspruchs; leer bedeutet KEIN Mandant, nie „alle". */
  const companyIds = computed<string[]>(() => anspruch.value?.companyIds ?? []);

  /**
   * IST DER ANSPRUCH UEBERHAUPT GELESEN (T-M34.10, 2026-09-08 —
   * REQ-OPS-058 Praez. 2 (g1)/(g2))?
   *
   * ⚠ **DAS IST KEINE AUSSAGE UEBER SEINEN INHALT.** Ein gelesener Anspruch
   * ohne Admin-Recht und ohne eine einzige Kennung ist `true` — er ist gelesen,
   * er traegt bloss nichts. Wer diese Auskunft als „darf etwas" liest, hat sie
   * missverstanden; wer fragt, ob jemand etwas darf, fragt {@link darfMandant},
   * und das bleibt streng (ohne Anspruch `false`).
   *
   * **WOFUER:** die Pruefung der gespeicherten Mandantenwahl
   * (`companyStore.pruefeMandantenwahl`) darf die strenge Antwort nicht auf
   * einen Anspruch stellen, der noch gar nicht gelesen wurde — sonst nimmt sie
   * eine gueltige Sitzungsangabe zurueck, bloss weil sie zu frueh gefragt hat.
   * **An einer BILDSCHIRM-Adresse wird er ueberhaupt nie gelesen** (`amPortal
   * === false` in `verarbeiteAnmeldezustand`), obwohl der Start dort regulaer
   * endet — „Start beendet" und „Anspruch gelesen" sind zwei verschiedene
   * Tatsachen, und genau dieser Unterschied war der Feldbefund vom 2026-09-08.
   *
   * `leseAnspruch` wirft nie und liefert im Fehlschlag den ENGSTEN Anspruch
   * (`KEIN_ANSPRUCH`, `utils/anspruch.ts`): auch dieser Ausgang ist ein
   * gelesener Anspruch und wird hier bewusst als solcher gefuehrt. Zurueck auf
   * `null` faellt der Wert allein mit der Sitzung (`logout`, Abmeldung).
   */
  const anspruchGelesen = computed(() => anspruch.value !== null);

  /**
   * WIRD DER ANSPRUCH GERADE GELESEN (T-M47.2 Kriterium 5, 2026-10-06 —
   * REQ-OPS-058 Praez. 2 (e) samt Nachtrag 2026-10-05 an Praez. 4)?
   *
   * `true` von dem Augenblick an, in dem `verarbeiteAnmeldezustand` einen
   * angemeldeten Benutzer AM PORTAL uebernimmt (`firebaseUser` ist dann schon
   * gesetzt), bis der Durchgang auf irgendeinem Weg endet — gelesener Anspruch,
   * Abmeldung (Anzeige-Token, abgelaufene Sitzung) oder Fehler.
   *
   * ⚠ **WOFUER:** bei der FRISCHEN Anmeldung ist der Anmeldestart schon mit
   * `signedOut` beendet (`isLoading === false`), wenn der Benutzer eintrifft —
   * `warteAufAnmeldestart` im Router-Waechter kehrt deshalb sofort zurueck, und
   * bis zum 2026-10-06 entschied der Waechter in diesem Fenster OHNE gelesenen
   * Anspruch ueber die gespeicherte Kennung (Befund B2, M47 V.3). Der Waechter
   * wartet seither auf {@link anspruchGelesen}, solange dieses Merkmal steht.
   *
   * **Es ist KEIN zweites „gelesen"-Signal** — das bleibt `anspruchGelesen`.
   * Es sagt allein, ob sich Warten lohnt: an einer Bildschirm-Adresse wird der
   * Anspruch absichtlich NIE gelesen (REQ-OPS-058 Praez. 2 (g1)/(g2)), und ein
   * Waechter, der dort auf ihn wartete, wartete bis zur Frist.
   */
  const anspruchAusstehend = ref(false);
  /** Laufende Nummer der Anspruchslesung; ein neuerer Durchgang entwertet den vorigen. */
  let _anspruchLauf = 0;

  /**
   * Darf dieser Benutzer den genannten Mandanten sehen (REQ-SEC-028 (a))?
   *
   * Ein Admin darf jede Kennung; ein `user` genau die aus seinem Anspruch.
   * **Ohne gelesenen Anspruch ist die Antwort `false`** — die strenge Richtung.
   */
  function darfMandant(id: string | null | undefined): boolean {
    if (!id) return false;
    if (isAdmin.value) return true;
    return companyIds.value.includes(id);
  }

  // ── Actions ────────────────────────────────────────────────────────────────

  /**
   * Liest das Firestore-Profil des angemeldeten Benutzers.
   *
   * ⚠ **DIESE FUNKTION LIEST NUR — SIE SCHREIBT NICHTS MEHR** (T-M30.7,
   * REQ-SEC-029 (b) Praez. 1, REQ-DM-070 (e)). *Bis zum 2026-09-01 legte sie
   * beim Erstlogin selbst ein `users`-Dokument an; berichtigt statt geloescht
   * (REQ-OPS-036 Praez. 6). Die Erstanlage war der einzige Weg, auf dem ein
   * Client sein EIGENES `users`-Dokument beschrieb — mit Kundenlogins waere das
   * der kuerzeste Weg zur Selbst-Befoerderung. Das Profil entsteht ab jetzt
   * ausschliesslich in `acceptinvitation` (REQ-SEC-030).*
   *
   * **Fehlt das Dokument, ist das ein benannter Fehlerzustand** — geworfen mit
   * {@link PROFIL_FEHLT_CODE}, damit die Fehleransicht ihn nennen und an den
   * Administrator verweisen kann; NICHT ein Anlass zum Schreiben.
   *
   * Der Lesevorgang laeuft durch {@link mitAnspruchsWiederholung}: ein
   * `permission-denied` kann ein VERALTETES Token sein (REQ-SEC-028 (f)), und
   * dann ist der Anspruch aufzufrischen und der Versuch EINMAL zu wiederholen,
   * bevor der Fehler angezeigt wird.
   *
   * Gefangen wird hier NICHTS — der Fehlerpfad liegt beim Aufrufer
   * (`verarbeiteAnmeldezustand`), damit es genau EINEN gibt.
   */
  async function fetchAppUser(user: User, amPortal: boolean): Promise<void> {
    const ref = doc(db, 'users', user.uid);
    const beginnLesen = Date.now();
    // Der Wiederholversuch gilt der VERWALTUNGSoberflaeche (REQ-SEC-028 (f)).
    // An einer Bildschirm-Adresse waere er ein Netzvorgang im Startpfad einer
    // Kiosk-Ansicht, der nichts heilen kann: ein Anzeige-Token traegt keinen
    // `admin`- und keinen `companyIds`-Anspruch, und die Ablehnung des
    // Profil-Lesens ist dort der ERWARTETE Ausgang (T-M24.2, Fall 5b).
    const lies = () => getDoc(ref);
    const snap = amPortal ? await mitAnspruchsWiederholung('users', lies) : await lies();
    diagnoseBootstrapStep('profileRead', Date.now() - beginnLesen, {
      userId: user.uid,
      phase:  'read',
    });
    if (!snap.exists()) {
      diagnoseAuthState('profileMissing', { userId: user.uid, code: PROFIL_FEHLT_CODE }, 'error');
      throw {
        code:    PROFIL_FEHLT_CODE,
        message: 'Zu diesem Konto besteht kein Benutzerprofil. Bitte wenden Sie sich an Ihren Administrator.',
      };
    }
    appUser.value = { uid: user.uid, ...snap.data() } as AppUser;
  }

  // ── Der Start: Frist, Ausgaenge, Neuversuch (REQ-OPS-052) ──────────────────

  /** Nimmt den Zeitgeber der Frist zurueck (mehrfach aufrufbar). */
  function loescheFrist(): void {
    if (_frist !== null) { clearTimeout(_frist); _frist = null; }
  }

  /**
   * Startet die Frist neu (REQ-OPS-052 (b)).
   *
   * Laeuft sie ab, gilt der Start als gescheitert — auch dann, wenn die
   * ausstehende Antwort spaeter noch eintrifft. Ein Nachzuegler bekommt seine
   * eigene Protokollzeile und hebt den Fehlerzustand NICHT still wieder auf;
   * wer weitermachen will, drueckt „Erneut versuchen".
   */
  function starteFrist(): void {
    loescheFrist();
    const lauf     = _lauf;
    const begonnen = Date.now();
    _startBegonnen = begonnen;
    _startBeendet  = false;
    _frist = setTimeout(() => {
      _frist = null;
      if (lauf !== _lauf || _startBeendet) return;
      scheitert(lauf, 'timeout', begonnen, {
        code:    BOOTSTRAP_TIMEOUT_CODE,
        message: `Der Anmelde-Start hat die Frist von ${BOOTSTRAP_TIMEOUT_MS} ms ueberschritten.`,
      });
    }, BOOTSTRAP_TIMEOUT_MS);
  }

  /** Ein gelungener Ausgang: der Ladezustand faellt, die Frist endet. */
  function beende(lauf: number, schritt: string, begonnen: number): void {
    if (lauf !== _lauf) return;          // ein neuerer Start hat uebernommen
    const dauer = Date.now() - begonnen;
    if (_startBeendet) {
      // Kein Startschritt mehr, sondern ein spaeterer Anmeldewechsel oder ein
      // Nachzuegler nach Fristablauf — protokolliert, aber ohne Wirkung auf den
      // Ladezustand.
      diagnoseBootstrapStep(schritt, dauer, { phase: 'afterBootstrap' });
      return;
    }
    _startBeendet = true;
    loescheFrist();
    isLoading.value = false;
    diagnoseBootstrapStep(schritt, dauer, { phase: 'bootstrap' });
  }

  /**
   * Ein gescheiterter Ausgang (REQ-OPS-052 (c)): der Ladezustand faellt, der
   * benannte Fehlerzustand traegt Code und Meldung, die Frist endet.
   */
  function scheitert(lauf: number, schritt: string, begonnen: number, err: unknown): void {
    if (lauf !== _lauf) return;
    // `fehlerAngaben` deckt beide Faelle: einen geworfenen Firebase-Fehler und
    // den von Hand gebildeten Zustand des Fristablaufs (`{ code, message }`).
    const angaben = fehlerAngaben(err);
    diagnoseBootstrapStep(
      schritt,
      Date.now() - begonnen,
      { code: angaben.code, message: angaben.message, phase: 'bootstrap' },
      'error',
    );
    _startBeendet   = true;
    loescheFrist();
    bootstrapError.value = angaben;
    isLoading.value      = false;
  }

  /**
   * Ein Anmeldezustand ist eingetroffen — der ganze Start in EINEM Fehlerpfad
   * (REQ-OPS-052 (a)): Sitzungspruefung, Profil-Lesen UND Erstanlage.
   */
  async function verarbeiteAnmeldezustand(user: User | null): Promise<void> {
    const lauf     = _lauf;
    const begonnen = _startBeendet ? Date.now() : _startBegonnen;
    // T-M47.2 Kriterium 5: steht ab hier, bis dieser Durchgang endet (finally).
    const anspruchLauf = ++_anspruchLauf;
    anspruchAusstehend.value = user !== null
      && istPortalPfad(typeof location === 'undefined' ? '' : (location.pathname ?? ''));
    firebaseUser.value = user;
    diagnoseAuthState(user ? 'signedIn' : 'signedOut', user ? { userId: user.uid } : undefined);
    try {
      if (user) {
        // ── Ein Anzeige-Token ist keine Anmeldung (REQ-OPS-052 Praez. 1) ────
        // ⚠ DIESE PRUEFUNG STEHT VOR DEM SITZUNGSZWEIG, und das ist der
        // Unterschied zwischen „behoben" und „halb behoben": der Zweig darunter
        // SCHREIBT `pf_login_at`, und eine Bildschirm-Sitzung hinterliesse damit
        // die Marke einer Verwaltungssitzung (Nebenbefund (iii) aus T-M24.1).
        // Die Erkennung selbst liegt an EINER Stelle — in
        // `utils/bildschirmSitzung.ts` —, liest den ANSPRUCH des Ausweises und
        // greift nur am Portal, nicht in den drei Bildschirm-Ansichten.
        // Der lokale Name lautet `bildschirmBefund` und nicht `anspruch`: seit
        // T-M30.7 traegt der Store einen Zustand dieses Namens (der Custom
        // Claim, REQ-SEC-028) — zwei verschiedene Dinge, ein Name waere hier
        // die teuerste Art von Beilaeufigkeit.
        // Der Pfad wird EINMAL gelesen und zweimal gebraucht — die Erkennung
        // unten und die Anspruchsfrage weiter unten stellen dieselbe Frage
        // („laeuft dieser Start am Portal?") und duerfen sie nicht getrennt
        // beantworten.
        const pfad     = typeof location === 'undefined' ? '' : (location.pathname ?? '');
        const amPortal = istPortalPfad(pfad);
        const bildschirmBefund = await erkenneBildschirmSitzungAmPortal(user, pfad);
        if (bildschirmBefund.istBildschirm) {
          // Die EINE Zeile im Diagnose-Protokoll, Klasse „Sitzungsentscheide"
          // (REQ-OPS-055 (b), T-M24.2 Umfang (3)). Stufe `warn`: der Zustand ist
          // behebbar — der Bediener meldet sich an. Der Anzeige-SCHLUESSEL steht
          // hier ausdruecklich NICHT (REQ-OPS-055 (d)); der Kanal steht als
          // `printerId`, weil er im Feld die Herkunft der Sitzung benennt.
          diagnoseSessionDecision(
            'screenTokenRejected',
            {
              userId:    user.uid,
              printerId: bildschirmBefund.printerId,
              verdict:   'screenToken' satisfies SitzungsVerdikt,
              source:    SITZUNGSSTELLE.start,
            },
            'warn',
          );
          // Abmelden — und den Anmeldezustand SOFORT zuruecknehmen, ohne auf den
          // Rueckruf von Firebase zu warten: der Router-Waechter fragt gleich
          // danach, und `isAuthenticated` muss dann bereits falsch sein, damit
          // die Oberflaeche nach `/login` fuehrt (REQ-OPS-052 Praez. 1).
          await logout();
          firebaseUser.value = null;
          // Ein REGULAERER Ausgang des Starts: der Ladezustand faellt, es
          // entsteht KEIN `bootstrapError` und damit keine Fehleransicht.
          beende(lauf, 'screenTokenSignedOut', begonnen);
          return;
        }

        // ── Session-Timeout prüfen ─────────────────────────────────────────
        // ⚠ STELLE 1 VON ZWEIEN, und sie ist die NACHSICHTIGE (REQ-OPS-056 (b)).
        // Ein fehlender Zeitstempel gilt HIER als FRISCH und wird gesetzt —
        // nicht aus Nachlaessigkeit: `login()` schreibt ihn nicht, also ist er
        // nach jeder frischen Anmeldung genau hier zum ersten Mal faellig.
        // Wer diesen Zweig dem Waechter angleicht (fehlend = abgelaufen),
        // meldet JEDE FRISCHE ANMELDUNG SOFORT WIEDER AB. Gehalten von
        // `test/sitzungsAsymmetrie.test.ts`.
        const storedAt = localStorage.getItem(SESSION_KEY);
        if (!storedAt) {
          // Erstes Laden nach Login → Zeitstempel setzen
          protokolliereSitzungsentscheid(SITZUNGSSTELLE.start, storedAt, 'fresh');
          localStorage.setItem(SESSION_KEY, String(Date.now()));
        } else if (isSessionExpired(storedAt)) {
          // Session abgelaufen → sofort ausloggen (vor fetchAppUser)
          protokolliereSitzungsentscheid(SITZUNGSSTELLE.start, storedAt, 'expired');
          console.info('[AuthStore] Session abgelaufen – automatisch ausloggen.');
          await logout();
          beende(lauf, 'sessionExpired', begonnen);
          return;
        } else {
          protokolliereSitzungsentscheid(SITZUNGSSTELLE.start, storedAt, 'valid');
        }

        // ── DER ANSPRUCH, AUFGEFRISCHT (T-M30.7, REQ-SEC-028 (f)) ──────────
        // Hier — und nur hier — wird das ID-Token beim Anmelden ERZWUNGEN
        // erneuert. Der Anmelde-Start ist die eine Stelle, die JEDE Anmeldung
        // durchlaeuft: die frische ueber `login()` ebenso wie die aus dem
        // `localStorage` wiederhergestellte Sitzung, deren Token bis zu einer
        // Stunde alt sein kann. Eine zweite Auffrischung in `login()` waere ein
        // zweiter Netzvorgang fuer dieselbe Tatsache.
        // ⚠ Die Auffrischung steht VOR `fetchAppUser`: der Lesevorgang auf
        // `users/{uid}` haengt selbst am Anspruch (REQ-SEC-029 (a)).
        // ⚠ NUR AM PORTAL: an einer Bildschirm-Adresse wird der Anspruch gar
        // nicht erst gelesen — dort ist er der Normalfall und keine
        // Feststellung wert, und ein erzwungenes Erneuern waere ein
        // Netzvorgang im Startpfad einer Kiosk-Ansicht (dieselbe Abwaegung wie
        // in `utils/bildschirmSitzung.ts`, T-M24.2).
        if (amPortal) {
          const beginnAnspruch = Date.now();
          anspruch.value = await leseAnspruch(user, { auffrischen: true });
          diagnoseBootstrapStep('claimRead', Date.now() - beginnAnspruch, {
            userId: user.uid,
            count:  anspruch.value.companyIds.length,
            phase:  'bootstrap',
          });
        }

        await fetchAppUser(user, amPortal);
      } else {
        appUser.value  = null;
        anspruch.value = null;
      }
      beende(lauf, user ? 'ready' : 'signedOut', begonnen);
    } catch (err) {
      // HIER endet der Start im Fehlerfall — statt den Ladezustand stehen zu
      // lassen, wie es bis zum 2026-08-18 geschah.
      scheitert(lauf, 'failed', begonnen, err);
    } finally {
      // Jeder Ausgang beendet das Warten — auch Abmeldung und Fehler: ein
      // Waechter, der danach weiter wartete, haengte bis zur Frist.
      if (anspruchLauf === _anspruchLauf) anspruchAusstehend.value = false;
    }
  }

  /** Listen to Firebase Auth state changes and sync the store. */
  function init(): void {
    if (_initialized) return;   // guard: only one listener allowed
    _initialized = true;
    starteFrist();
    _abmelder = onAuthStateChanged(
      auth,
      (user) => { void verarbeiteAnmeldezustand(user); },
      // Der Anmeldeweg selbst kann scheitern (Netz, ungueltiger Ausweis) — auch
      // dieser Ausgang laesst den Ladezustand nicht stehen (REQ-OPS-052 (a)).
      (err) => { scheitert(_lauf, 'authStateFailed', _startBegonnen, err); },
    );
  }

  /**
   * Den Start wiederholen — OHNE die Seite neu zu laden (REQ-OPS-052 (d),
   * REQ-OPS-054 (d)).
   *
   * Der laufende Anmelde-Listener wird abgeraeumt und neu gesetzt: damit
   * durchlaeuft der Start dieselbe Kette noch einmal (Sitzungspruefung,
   * Anspruch, Profil) statt bloss den Fehlerzustand zu verbergen. Die laufende Nummer
   * entwertet den vorigen Start; eine spaet eintreffende Antwort von damals
   * kann den neuen nicht mehr beenden.
   */
  function retryBootstrap(): void {
    _lauf += 1;
    bootstrapError.value = null;
    isLoading.value      = true;
    loescheFrist();
    if (_abmelder) { _abmelder(); _abmelder = null; }
    _initialized = false;
    diagnoseAuthState('bootstrapRetry', { source: 'user' });
    init();
  }

  /**
   * Den Start von aussen als gescheitert erklaeren, weil die Frist abgelaufen
   * ist (REQ-OPS-052 (e)).
   *
   * Gerufen vom Router-Waechter, der nie laenger auf das Ende des Ladezustands
   * wartet als der Start dauern darf — und danach in DENSELBEN Fehlerfall
   * faellt. Mehrfach aufrufbar: ein bereits beendeter Start bleibt unberuehrt.
   */
  function failBootstrapTimeout(source = 'router'): void {
    if (bootstrapError.value || !isLoading.value) return;
    const begonnen = _startBegonnen || Date.now();
    diagnoseAuthState('bootstrapTimeout', { source }, 'error');
    scheitert(_lauf, 'timeout', begonnen, {
      code:    BOOTSTRAP_TIMEOUT_CODE,
      message: `Der Anmelde-Start hat die Frist von ${BOOTSTRAP_TIMEOUT_MS} ms ueberschritten (${source}).`,
    });
  }

  /** Den Fehlerzustand zuruecknehmen, ohne den Start zu wiederholen. */
  function clearBootstrapError(): void {
    bootstrapError.value = null;
  }

  /** Sign in with email and password. */
  async function login(email: string, password: string): Promise<void> {
    error.value = null;
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err: unknown) {
      const message = (err as { message?: string }).message ?? 'Unbekannter Fehler';
      error.value = translateAuthError(message);
      throw err;
    }
  }

  /** Sign out the current user and clear session timestamp. */
  async function logout(): Promise<void> {
    localStorage.removeItem(SESSION_KEY);  // ← Session-Timestamp löschen
    await signOut(auth);
    appUser.value  = null;
    // Der Anspruch gehoert der Sitzung und nicht dem Browser: er faellt mit ihr
    // (REQ-SEC-028). Ein stehengebliebener Anspruch liesse die Oberflaeche nach
    // der Abmeldung Admin-Flaechen zeigen.
    anspruch.value = null;
  }

  /**
   * Prüft ob die aktuelle Session noch gültig ist (< 12h).
   * Gibt true zurück wenn die Session abgelaufen ist und der User ausgeloggt wurde.
   * Wird im Router-Guard bei jeder Navigation aufgerufen.
   *
   * ⚠ **STELLE 2 VON ZWEIEN, und sie ist die STRENGE** (REQ-OPS-056 (a)): ein
   * fehlender Zeitstempel gilt HIER als **abgelaufen**, weil die Sitzung dann
   * nicht rekonstruierbar ist und die sicherere Wahl gewinnt. Dass Stelle 1
   * (`init()`) denselben Wert als **frisch** liest, ist entschieden und
   * notwendig — die Begruendung steht im Kopf dieser Datei, der Waechter in
   * `test/sitzungsAsymmetrie.test.ts`.
   */
  async function checkSessionExpiry(): Promise<boolean> {
    if (!firebaseUser.value) return false;  // nicht eingeloggt → nichts zu prüfen
    const storedAt = localStorage.getItem(SESSION_KEY);
    // Fehlender Zeitstempel gilt hier als abgelaufen (Sitzung nicht rekonstruierbar).
    if (!storedAt || isSessionExpired(storedAt)) {
      protokolliereSitzungsentscheid(SITZUNGSSTELLE.waechter, storedAt, 'expired');
      console.info('[AuthStore] Session abgelaufen – ausloggen.');
      await logout();
      return true;  // Session war abgelaufen
    }
    protokolliereSitzungsentscheid(SITZUNGSSTELLE.waechter, storedAt, 'valid');
    return false;
  }

  return {
    firebaseUser,
    appUser,
    isLoading,
    error,
    bootstrapError,
    isAuthenticated,
    // ⚠ ENTFALLEN AM 2026-09-01 (T-M30.7, REQ-DM-070 (e)): `companyId`. Es las
    // `appUser.companyId` — ein Feld, das die 1-n-Beziehung zwischen Benutzer
    // und Mandanten strukturell nicht abbilden kann und neben `members` eine
    // zweite Fuehrung derselben Tatsache waere. An seine Stelle treten
    // `companyIds` (der Anspruch) und `companyStore.selectedCompanyId` (die
    // Sitzungsangabe). *Berichtigt statt geloescht — REQ-OPS-036 Praez. 6.*
    anspruch,
    anspruchGelesen,
    anspruchAusstehend,
    companyIds,
    isAdmin,
    darfMandant,
    init,
    login,
    logout,
    checkSessionExpiry,
    retryBootstrap,
    failBootstrapTimeout,
    clearBootstrapError,
  };
});

// ── Error translation ─────────────────────────────────────────────────────────

function translateAuthError(message: string): string {
  if (message.includes('user-not-found') || message.includes('wrong-password') || message.includes('invalid-credential')) {
    return 'E-Mail oder Passwort ungültig.';
  }
  if (message.includes('too-many-requests')) {
    return 'Zu viele Anmeldeversuche. Bitte warten.';
  }
  if (message.includes('network-request-failed')) {
    return 'Netzwerkfehler. Bitte Verbindung prüfen.';
  }
  return message;
}
